import { useEffect } from 'react'
import useGameStateHook from './useGameStateHook'
import { useDispatch, useSelector } from 'react-redux'
import { userLogin } from 'redux-store/thunk/auth.thunk'
import { useLocation, useHistory } from 'react-router-dom'
import { fetchUserInformation } from 'redux-store/thunk/user.thunk'
import { ROUTE_GAME_NAME_ID } from 'utils/constants/index'
import useCustomTranslation from 'hooks/useCustomTranslation'
import { getAllCurrency, getGameSetting } from 'redux-store/thunk/gameSettings.thunk'

const useOperatorAuthentication = () => {
  /* ======================================= Custom Hooks ======================================= */

  // custom-hook to manage the inactive games
  useGameStateHook()

  /* ======================================= inbuilt Hooks ======================================= */

  const dispatch = useDispatch()
  const { search } = useLocation()
  const history = useHistory()
  const { changeLanguage } = useCustomTranslation()

  /* =======================================  use selector Hooks ======================================= */

  const { isLoggedIn } = useSelector((state) => state.auth)

  /* =======================================  URL parameter ======================================= */

  const operatorId = new URLSearchParams(search).get('operator')
  const playerToken = new URLSearchParams(search).get('token')
  const currencyCode = new URLSearchParams(search).get('currency')
  const lang = new URLSearchParams(search).get('lang')

  /* =======================================  Functions ======================================= */

  const handleLoginUser = (gameId) => {
    const params = {
      payload: {
        operatorId,
        operatorUserToken: playerToken,
        currencyCode,
        gameId
      },
      history
    }
    dispatch(userLogin(params))
  }

  /* =======================================  useEffect Hooks ======================================= */

  useEffect(() => {
    if (playerToken && currencyCode && operatorId) {
      const id = ROUTE_GAME_NAME_ID[window.location.pathname]
      document.title = `Operator-${operatorId}-site`
      changeLanguage(lang)
      handleLoginUser(id)
    }
  }, [playerToken, currencyCode, operatorId, lang])

  useEffect(() => {
    if (isLoggedIn) {
      dispatch(getAllCurrency())
      dispatch(fetchUserInformation())
      dispatch(getGameSetting({ operatorId }))
    }
  }, [isLoggedIn])

  /* ======================================= Return data ======================================= */

  return {
    isLoggedIn
  }
}

export default useOperatorAuthentication
